export default __webpack_public_path__ + "static/media/fundamentals_ML_finance.fa57fa49.png";